import FormItem from "@components/formItem";
import PaymentSelect from "@components/paymentSelect/index.jsx";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { getUser } from "@utils";
import React from "react";
import MaskInput from "react-maskinput";
import { Box, BoxTitle, BoxWrapper, Content, ContentTitle, MaskedInput } from "../../baseItems";
import Base from "../base";
import Institutions from "./institutions.json";

export default class STP extends Base {
	getStep1(translate) {
		const { institution, clabe } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "clabe" })}>
						<Box>
							<BoxTitle>{translate("CLABE_CODE")}</BoxTitle>
							<MaskedInput>
								<MaskInput
									alwaysShowMask={window.IS_MARS ? true : false}
									maskChar={"_"}
									mask="000000000000000000"
									size={18}
									onChange={(e) => this.onEnterValue("clabe", e)}
									value={clabe}
								/>
							</MaskedInput>
						</Box>
					</FormItem>

					<FormItem onRegister={() => this.registerField({ name: "institution" })}>
						<Box>
							<BoxTitle>{translate("INSTITUTION")}</BoxTitle>
							<PaymentSelect
								options={Object.keys(Institutions).map((institution) => ({
									value: institution,
									label: Institutions[institution],
								}))}
								value={institution}
								handleSelect={(v) => this.setState({ institution: v?.value })}
							/>
						</Box>
					</FormItem>
				</BoxWrapper>
			</Content>
		);
	}

	makeExternalPayment() {
		const { stake, clabe, institution, selectedCurrency } = this.state;
		let withdrawData = {
			clabe,
			institution,
			type: "STP",
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			username: getUser().username,
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
